
import { Layout, theme, Avatar, Flex, Grid } from 'antd';

import { useEffect, useState } from 'react';

import { Breadcrumb } from '@/Components/Breadcrumb';
import { CentroCusto } from '../Cadastros/CentroDeCusto/CentroDeCusto';
import { Estoque } from '../Cadastros/Estoque/Estoque';
import { Grupo } from '../Cadastros/Estoque/Grupo';
import { GuiaCadastral } from '@/Components/GuiaCadastral';
import { Home } from './Home';
import { Material } from '../Cadastros/Estoque/Material';
import { Menu } from '@/Components/Sistema/Menu/Menu';
import { NaoEncontrado } from './404';
import { PlanoDeContas } from '../Cadastros/PlanoDeContas/PlanoDeContas';
import { Route, Routes, useLocation, useRoutes } from 'react-router-dom';
import { useSessaoObrigatorio } from '@/Contexts/SessaoContext';
import { Subgrupo } from '../Cadastros/Estoque/Subgrupo';
import { Testes } from "./Testes";
import { Banco } from '../Cadastros/Banco/Banco';
import { Agencia } from '../Cadastros/Agencia/Agencia';
import { Conta } from '../Cadastros/Conta/Conta';

import Faturamento from '../Faturamento';
import Financeiro from '../Financeiro';
import MovimentacaoScreen from '@/Components/Populados/Financeiro/Conta/Movimentacao/MovimentacaoScreen';
import ConciliacaoAuttarScreen from '@/Components/Populados/Financeiro/Conta/Conciliacao/Auttar/ConciliacaoAuttarScreen';
import ConciliacaoGetNetLiquidaScreen from '@/Components/Populados/Financeiro/Conta/Conciliacao/Auttar/ConciliacaoGetNetLiquidaScreen';
import ConciliacaoGetNetExtratoEletronicoScreen from '@/Components/Populados/Financeiro/Conta/Conciliacao/Auttar/ConciliacaoGetNetExtratoEletronicoScreen';
import ConciliacaoPagBankScreen from '@/Components/Populados/Financeiro/Conta/Conciliacao/Auttar/ConciliacaoPagBankScreen';

import { LOCAL_STORAGE_JWT_KEY } from '@/Constants';
import { AlterarSenha } from '@/Components/AlterarSenha';
import { PerfilRouter } from '../../Components/Populados/Perfil/PerfilRouter';
import { Empresa } from '../Cadastros/Empresa/Empresa';
import { Fornecedor } from '../Cadastros/Fornecedor/Fornecedor';
import { Cliente } from '../Cadastros/Cliente/Cliente';
import { Usuario } from '../Cadastros/Usuario/Usuario';
import { Escola } from '../Cadastros/Escola/Escola';
import Aluno from '../Aluno';
import Responsavel from '../Responsavel';
import { Viagem } from '../Viagem/Cadastros/Viagem/Viagem';
import TituloScreen from '@/Components/Populados/Financeiro/Titulo/TituloScreen';
import Vacina from '../FichaDeSaude/Vacina';
import { Perfil } from '../Cadastros/Perfil/Perfil';
import Alergia from '../FichaDeSaude/Alergia';
import Enfermidade from '../FichaDeSaude/Enfermidade';
import NotaScreen from '@/Components/Populados/Financeiro/Titulo/Nota/NotaScreen';
import InscricaoDescontoScreen from '@/Components/Populados/Viagem/Inscricao/InscricaoDesconto/InscricaoDescontoScreen';
import TipoDeViagem from '../Viagem/Cadastros/TipoDeViagem';
import Destino from '../Viagem/Cadastros/Destino';
import Certificado from '../Faturamento/Certificado';
import Servico from '../Faturamento/Servico';
import RelatorioScreen from '@/Components/Populados/Relatorio/RelatorioScreen';
import { TodasInscricoesScreen } from '@/Components/Populados/Viagem/Inscricao/TodasInscricoes/TodasInscricoesScreen';
import ContaViagemTabs from '@/Components/Populados/Viagem/Financeiro/ContaViagem/ContaViagemTabs';
import FeriadoConsultaScreen from '@/Components/Populados/geral/data/feriado/FeriadoConsultaScreen';

const { Content, Sider, Footer } = Layout;
const { useBreakpoint } = Grid;

export function MasterPage(props: { temaEscuro: boolean, setTemaEscuro: (tema: boolean) => void }) {
    const { sessao, setSessao } = useSessaoObrigatorio();
    const _location = useLocation();

    const tamanhoDaTela = useBreakpoint();
    const tokenDoTema = theme.useToken();

    const [exbirAlterarSenha, setExibirAlterarSenha] = useState(false);
    const [siderCollapsed, setSiderCollapsed] = useState(true);

    function deslogarUsuario() {
        localStorage.setItem(LOCAL_STORAGE_JWT_KEY, "");
        setSessao(null);
    }

    const { pathname } = useLocation();

    useEffect(() => {
        if (!tamanhoDaTela.lg) {
            setSiderCollapsed(true)
        }
    }, [_location, tamanhoDaTela])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const routes = useRoutes([
        { path: "/", index: true, element: <Home /> },
        {
            path: "/viagens/*",
            children: [
                { path: "viagens/*", element: <Viagem /> },
                { path: "inscricoes-recentes/*", element: <TodasInscricoesScreen /> },
                { path: "descontos/*", element: <InscricaoDescontoScreen /> },
                { path: "adv/*", element: <ContaViagemTabs /> },
                { path: "alunos/*", element: <Aluno /> },
                { path: "responsaveis/*", element: <Responsavel /> },
                { path: "tipos-de-viagem/*", element: <TipoDeViagem /> },
                { path: "destinos/*", element: <Destino /> },
            ],
        },
        {
            path: "/financeiro/*",
            children: [
                { path: "boletos/*", element: <>Não implementado</> },
                { path: "titulos/*", element: <TituloScreen /> },
                { path: "movimentacoes/*", element: <MovimentacaoScreen /> },
                { path: "conciliacao-auttar/*", element: <ConciliacaoAuttarScreen /> },
                { path: "conciliacao-getnet/*", element: <ConciliacaoGetNetLiquidaScreen /> },
                { path: "conciliacao-getnet-extrato-eletronico/*", element: <ConciliacaoGetNetExtratoEletronicoScreen /> },
                { path: "conciliacao-pagbank/vendas/*", element: <ConciliacaoPagBankScreen tipo="VENDAS" /> },
                { path: "conciliacao-pagbank/pagamentos/*", element: <ConciliacaoPagBankScreen tipo="PAGAMENTOS" /> },
                { path: "conciliacao-pagbank/cancelamentos/*", element: <ConciliacaoPagBankScreen tipo="CANCELAMENTO" /> },
                { path: "notas/*", element: <NotaScreen /> },
            ],
        },
        { path: "/relatorios/*", element: <RelatorioScreen /> },
        {
            path: "/cadastros/*",
            children: [
                {
                    path: "empresas/*",
                    children: [
                        { path: "empresa/*", element: <Empresa /> },
                        { path: "fornecedor/*", element: <Fornecedor /> },
                        { path: "escola/*", element: <Escola /> },
                    ],
                },
                {
                    path: "bancos/*",
                    children: [
                        { path: "banco/*", element: <Banco /> },
                        { path: "agencia/*", element: <Agencia /> },
                        { path: "conta/*", element: <Conta /> },
                    ],
                },
                {
                    path: "contabilidade/*",
                    children: [
                        { path: "centro-de-custo/*", element: <CentroCusto /> },
                        { path: "plano-de-contas/*", element: <PlanoDeContas /> },
                    ],
                },
                { path: "usuarios/*", element: <Usuario /> },
            ],
        },
        {
            path: "/configuracoes/*",
            children: [
                { path: "perfil/*", element: <PerfilRouter /> },
                { path: "certificados/*", element: <Certificado /> },
                { path: "servicos/*", element: <Servico /> },
                {
                    path: "ficha-de-saude/*",
                    children: [
                        { path: "vacina/*", element: <Vacina /> },
                        { path: "alergia/*", element: <Alergia /> },
                        { path: "enfermidades/*", element: <Enfermidade /> },
                    ],
                },
            ],
        },
        {
            path: "/geral/*",
            children: [
                { path: "feriados/*", element: <FeriadoConsultaScreen /> }
            ],
        },
    ]);

    return (
        <Layout hasSider style={{ minHeight: "100vh" }}>
            <Sider
                collapsedWidth={tamanhoDaTela.lg ? undefined : "0"}
                collapsible
                collapsed={siderCollapsed}
                onCollapse={(value) => setSiderCollapsed(value)}
                width={250}
            >
                <Flex justify="center" style={{ margin: 16 }}>
                    <img
                        alt={`Logo ${process.env.REACT_APP_CLIENTE_NOME_RESUMIDO}`}
                        src={require("@/Assets/logo-quiron-branco.png")}
                        style={{ width: "100%", maxWidth: 150 }}
                    />
                </Flex>

                <Menu
                    colapsado={siderCollapsed}
                    itemsAntes={[
                        {
                            label: sessao.usuario?.nome,
                            key: "_menu_usuario_acoes",
                            icon: (
                                <Avatar shape="square" style={{ backgroundColor: "#eda051", fontWeight: 600, cursor: "default" }} size={16}>
                                    {sessao.usuario?.nome?.charAt(0).toUpperCase()}
                                </Avatar>
                            ),
                            children: [
                                {
                                    label: "Alterar senha",
                                    key: "_menu_usuario_acoes_alterar_senha",
                                    onClick: () => {
                                        setExibirAlterarSenha(true);
                                    },
                                },
                                {
                                    label: "Sair",
                                    key: "_menu_usuario_acoes_sair",
                                    onClick: deslogarUsuario,
                                },
                            ],
                        },
                    ]}
                />
            </Sider>

            <Layout style={{ padding: tamanhoDaTela.md ? "0 24px 24px" : "0 12px 12px" }}>
                <Breadcrumb style={{ margin: "16px 0px 16px 0px", fontWeight: 500 }} />
                <Content
                    style={{
                        padding: 24,
                        background: tokenDoTema.token.colorBgContainer,
                        borderRadius: tokenDoTema.token.borderRadiusLG,
                    }}
                >
                        {routes}

                    {/* <Routes>

                        <Route path="/" index element={<Home />} />

                        <Route path="/Estoque/Cadastros/Estoque/*" element={<Estoque />} />

                        <Route path="/Estoque/Cadastros/Grupo/*" element={<Grupo />} />
                        <Route path="/Estoque/Cadastros/Subgrupo/*" element={<Subgrupo />} />
                        <Route path="/Estoque/Cadastros/Material/*" element={<Material />} />

                        <Route path="/Financeiro/Cadastros/CentroCusto/*" element={<CentroCusto />} />
                        <Route path="/Financeiro/Cadastros/PlanoContas/*" element={<PlanoDeContas />} />
                        <Route path="/Financeiro/Cadastros/Banco/*" element={<Banco />} />
                        <Route path="/Financeiro/Cadastros/Agencia/*" element={<Agencia />} />
                        <Route path="/Financeiro/Cadastros/Conta/*" element={<Conta />} />

                        <Route path="/Viagem/*" element={<Viagem />} />

                        <Route path="/Pessoa/Cadastros/Empresa/*" element={<Empresa />} />
                        <Route path="/Pessoa/Cadastros/Fornecedor/*" element={<Fornecedor />} />
                        <Route path="/Pessoa/Cadastros/Cliente/*" element={<Cliente />} />
                        <Route path="/Pessoa/Cadastros/Escola/*" element={<Escola />} />
                        <Route path="/Pessoa/Cadastros/Aluno/*" element={<Aluno />} />
                        <Route path="/Pessoa/Cadastros/Responsavel/*" element={<Responsavel />} />

                        <Route path="/Pessoa/FichaDeSaude/Vacina/*" element={<Vacina />} />
                        <Route path="/Pessoa/FichaDeSaude/Alergia/*" element={<Alergia />} />
                        <Route path="/Pessoa/FichaDeSaude/Enfermidades/*" element={<Enfermidade />} />

                        <Route path="/Usuario/Cadastros/Usuario/*" element={<Usuario />} />
                        <Route path="/Usuario/Cadastros/Perfil/*" element={<PerfilRouter />} />

                        <Route path="/Testes/*" element={<Testes />} />

                        <Route path="/*" element={<NaoEncontrado />} />
                        <Route path="/404" element={<NaoEncontrado />} />

                        <Route path="/Faturamento/*" element={<Faturamento />} />
                        <Route path="/Financeiro/*" element={<Financeiro />} />
                        <Route path="/Financeiro/Movimentacao/*" element={<MovimentacaoScreen />} />
                        <Route path="/Financeiro/Conta/Conciliacao/Auttar/*" element={<ConciliacaoAuttarScreen />} />
                    </Routes> */}

                    <AlterarSenha exibir={exbirAlterarSenha} setExibir={setExibirAlterarSenha} />
                    <GuiaCadastral />
                </Content>

                <Footer style={{ textAlign: "center", bottom: 0, padding: 10 }}>
                    © {new Date().getFullYear()}{" "}
                    <a href="https://accessbrasil.net.br/" target="_blank" rel="noreferrer">
                        AccessBrasil
                    </a>{" "}
                    | Anchor Com. Serv. Informática Ltda. | Todos os direitos reservados.
                </Footer>
            </Layout>
        </Layout>
    );
}